import { Controller, useFormContext } from "react-hook-form";
import classNames from "classnames";

import ThemePaddingInput from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding-input";

import { useThemePadding } from "containers/admin/clients/client/theme-page/preview/components/theme-padding/use-theme-padding";

import { PaddingPropertyType } from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/layout.types";

import {
  PADDING_PROPERTIES,
  TOP_VALUE,
  RIGHT_VALUE,
  BOTTOM_VALUE,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/layout.constants";

import Icons from "assets";

interface ThemePaddingCustomProps {
  formFieldPrefix: string;
}

const ThemePaddingCustom = ({ formFieldPrefix }: ThemePaddingCustomProps) => {
  const { control } = useFormContext();
  const { handleCustomPaddingChange, handleCustomPaddingBlur } = useThemePadding(formFieldPrefix);

  const getIconClassName = (direction: PaddingPropertyType) => {
    switch (direction) {
      case TOP_VALUE:
        return "rotate-90";
      case RIGHT_VALUE:
        return "rotate-180";
      case BOTTOM_VALUE:
        return "-rotate-90";
      default:
        return "";
    }
  };

  return (
    <div className="grid grid-cols-2 gap-2 w-full">
      {PADDING_PROPERTIES.map((direction) => (
        <Controller
          key={direction}
          name={`${formFieldPrefix}.${direction}`}
          control={control}
          render={({ field }) => (
            <ThemePaddingInput
              value={field.value || ""}
              onChange={(value) => handleCustomPaddingChange(direction, value, field.onChange)}
              onBlur={(value) => handleCustomPaddingBlur(value, direction, field.onChange)}
              icon={
                <Icons.PaddingLeft className={classNames("size-4", getIconClassName(direction))} />
              }
            />
          )}
        />
      ))}
    </div>
  );
};

export default ThemePaddingCustom;
